import { focusManager, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useAccountContext } from '~/providers/AccountProvider';
import { getAccountKey } from '~/swr-hooks/account/useAccount';

/**
 * The account query uses `staleTime: Infinity`, which disables React
 * Query's built-in refetch-on-focus. While a pending email change is
 * active, force-invalidate when this tab regains focus so the banner and
 * notice clear once the user clicks the verification link in the other
 * tab — without requiring a manual reload.
 */
export const usePendingEmailFocusRefetch = () => {
  const queryClient = useQueryClient();
  const { data: account } = useAccountContext();
  const pendingEmail = account?.pendingEmail;

  useEffect(() => {
    if (!pendingEmail) {
      return;
    }

    return focusManager.subscribe((focused) => {
      if (focused) {
        queryClient.invalidateQueries({ queryKey: getAccountKey() });
      }
    });
  }, [pendingEmail, queryClient]);
};
